import { render, staticRenderFns } from "./alert-mail-demo.vue?vue&type=template&id=4f52a84c&"
import script from "./alert-mail-demo.vue?vue&type=script&lang=ts&"
export * from "./alert-mail-demo.vue?vue&type=script&lang=ts&"
import style0 from "./alert-mail-demo.vue?vue&type=style&index=0&id=4f52a84c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports